import { FormOption } from 'common/form';
import { ListTeam } from 'generated-graphql/types';

// The user's pickable teams, plus any of the list's teams they can't pick, so
// the current selection stays visible.
export const getTeamOptions = (
  teams: ListTeam[],
  currentTeams: ListTeam[]
): FormOption[] => {
  const pickableIds = new Set(teams.map(({ id }) => id));

  return [
    ...teams,
    ...currentTeams.filter(({ id }) => !pickableIds.has(id))
  ].map(({ id, name }) => ({ label: name, value: id }));
};
